import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
const tableData = {};
const pageConfig = {
    resetPage:null,
    loading:false,
    tableName:'downstream-sales',
    height:'',
    pageKey:getRandomString(),
    top_tools:{
        "HEADER":[
            // { index: 0, name: ['手动更新物料'], icon: 'fas fa-sync-alt', check_lines: 0, on_click: [], sign: 'updateErpMaterial', },
            { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            // { index: 1, name: ['手动接收'], icon: 'fas fa-hand-paper', check_lines: 0, on_click: [], sign: 'handleGet', },
        ]
    },
    pageConfig:{},
    pageConfigTree:[],
    dialogPage:{
        isPushIng:false,
        isFalsePagination:['DATA'],
        resetPage:null,
        loading:false,
        tableName:'downstream-sales-send-Dialog',
        height:'',
        pageKey:getRandomString(),
        getPageKey:'downstreamSales/getPushDataPageKey',
        top_tools:{},
        pageConfig:{},
        pageConfigTree:[],
        msgArr:[],
        completed:{}
    }
}
const state = () => ({
    downstreamSales: Object.assign({}, tableData,pageConfig),
})
const getters = {
    getPageConfig: state => state.downstreamSales.pageConfig,
    getPageConfigTree: state => state.downstreamSales.pageConfigTree,
    getPageKey:state => state.downstreamSales.pageKey,
    getPushDataDialog:state => state.downstreamSales.dialogPage,
    getPushDataPageKey:state => state.downstreamSales.dialogPage.pageKey,
    getPushMsg:state => state.downstreamSales.dialogPage.msgArr,
    geCompleted:state => state.downstreamSales.dialogPage.completed,
}
const mutations ={
    setRestPageFun(state, data){
        state.downstreamSales.resetPage = data;
    },
    setLoading(state, data){
        state.downstreamSales.loading = data;
        if(isNotEmpty(state.downstreamSales.pageConfig)){
            Object.keys(state.downstreamSales.pageConfig).forEach((key,index)=>{
                state.downstreamSales.pageConfig[key].loading = data;
            })
        }
    },
    setPageConfig(state, data){
        state.downstreamSales.pageConfig = data.pageConfig;
        state.downstreamSales.pageConfigTree = data.allArrData;
        state.downstreamSales.pageKey = getRandomString();
        if(isNotEmpty(state.downstreamSales.pageConfig)){
            Object.keys(state.downstreamSales.pageConfig).forEach((key,index)=>{
                state.downstreamSales.pageConfig[key].height = state.downstreamSales.height
            })
        }
    },
    setPushDialogConfig(state, data){
        state.downstreamSales.dialogPage.pageConfig = data.pageConfig;
        state.downstreamSales.dialogPage.pageConfigTree = data.allArrData;
        state.downstreamSales.dialogPage.pageKey = getRandomString();
        if(isNotEmpty(state.downstreamSales.dialogPage.pageConfig)){
            Object.keys(state.downstreamSales.dialogPage.pageConfig).forEach((key,index)=>{
                state.downstreamSales.dialogPage.pageConfig[key].height = state.downstreamSales.height
            })
        }
    },
    setPushDialogList(state, data){
        state.downstreamSales.dialogPage.pageConfig[data.obj].data = data.data;
        state.downstreamSales.dialogPage.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    setList(state, data) {
        state.downstreamSales.pageConfig[data.obj].data = data.data;
        state.downstreamSales.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    ['refreshTableHeight'](state, data) {
        state.downstreamSales.height = (data-80) + 'px';
        if(isNotEmpty(state.downstreamSales.pageConfig)){
            Object.keys(state.downstreamSales.pageConfig).forEach((key,index)=>{
                state.downstreamSales.pageConfig[key].height = state.downstreamSales.height;
            })
        }
        state.downstreamSales.dialogPage.height = (data-80) + 'px';
        if(isNotEmpty(state.downstreamSales.dialogPage.pageConfig)){
            Object.keys(state.downstreamSales.dialogPage.pageConfig).forEach((key,index)=>{
                state.downstreamSales.dialogPage.pageConfig[key].height = state.downstreamSales.height
            })
        }
    },
    ['clearData'](state, data) {
        clearRowDataDeep({tabName:data.tabName,pageConfig:state.downstreamSales.pageConfig,pageConfigTree:state.downstreamSales.pageConfigTree});
    },
    ['clear-push-msg'](state, data) {
        state.downstreamSales.dialogPage.isPushIng = false;
        state.downstreamSales.dialogPage.msgArr=[];
        state.downstreamSales.dialogPage.completed={};
    },
}
const actions = {
    ['handlePushData']({ state, dispatch, rootState ,commit}, payload) {
        state.downstreamSales.dialogPage.colseDialogFun = payload.colseDialogFun;
        if(state.downstreamSales.dialogPage.isPushIng){
            dispatch('response/negative', { message: '推送数据处理中，请误重复操作！' }, { root: true })
            return
        }
        delete payload.colseDialogFun;
        state.downstreamSales.dialogPage.isPushIng = true;
        let msg = { command: "post_client__outbound_push",message: payload,to: "client",'is_not_net_request':true}
        dispatch('response/info-tip', { message: '推送开始请耐心等待。。。' }, { root: true })
        dispatch('channel/socket_send', msg, { root: true })
    },
    ['pushDataReturn']({ state, commit,dispatch }, payload) {
        // state.downstreamSales.dialogPage.isPushIng = false;
        // state?.downstreamSales?.dialogPage?.colseDialogFun();
        state.downstreamSales.dialogPage.completed.data = 1;
        if (payload.success) {
            dispatch('response/success-tip', { message: '推送成功' }, { root: true })
            state?.downstreamSales?.resetPage({});
        }
    },
    async ['fetch-push-data-list']({ state, dispatch, rootState ,commit}, payload) {
        if(state.downstreamSales.dialogPage.isPushIng){
            dispatch('response/negative', { message: '推送数据处理中，请误重复操作！' }, { root: true })
            return
        }
        state.downstreamSales.dialogPage.pageConfig = {};
        state.downstreamSales.dialogPage.pageConfigTree = [];
        let msg = { command: "post_client__outbound_push_data",message: payload,to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async['return_list-push-data']({ state, commit }, payload) {
        if (payload.success) {
            let pageData = setPageConfig({
                pageData:payload.data.objs,
                tableName:state.downstreamSales.dialogPage.tableName,
                top_tools:state.downstreamSales.dialogPage.top_tools,
                isFalsePagination:state.downstreamSales.dialogPage.isFalsePagination
            });
            commit('setPushDialogConfig',pageData);
            let myCoums = await getMyColums({name:state.downstreamSales.dialogPage.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.downstreamSales.dialogPage.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            state.downstreamSales.dialogPage.pageConfigTree.forEach(page=>{
                page.columns.forEach(colItem=>{
                    if(colItem.field == 'F_MPG'){
                        colItem.isValueEmptyRedCell = true;
                    }
                })
            });
            commit('setPushDialogList',payload.data);
        }
    },
    async ['fetch-list']({ state, dispatch, rootState ,commit}, payload) {
        if(state.downstreamSales.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__outbound_history", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_list']({ state, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            if(!isNotEmpty(state.downstreamSales.pageConfigTree)){//生成 页面列配置 并处理成需要的结构
                let pageData = setPageConfig({pageData:payload.data.objs,tableName:state.downstreamSales.tableName,top_tools:state.downstreamSales.top_tools});
                commit('setPageConfig',pageData);
            }
            let myCoums = await getMyColums({name:state.downstreamSales.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.downstreamSales.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setList',payload.data);
        }
    },
    ['push_pushing_msg']({ state, commit }, payload) {
        state.downstreamSales.dialogPage.msgArr.unshift(payload);
        state.downstreamSales.dialogPage.msgArr.sort((a, b) => b.timestamp - a.timestamp);
    },
    ['set_pushing_completed']({ state, commit }, payload) {
        if(isNotEmpty(state.downstreamSales.dialogPage.completed) && state.downstreamSales.dialogPage.completed.time > payload.time){
            return
        }
        Object.keys(payload).forEach(key=>{
            state.downstreamSales.dialogPage.completed[key] = payload[key];
        })
    },
    ['return_export']({ state, commit }, payload) {
        if(payload.success){
            window.open(process.env.VUE_APP_APIHOST+'/'+payload.data);
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        let msg = { command: "get_client__outbound_export_excel", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
